export const itemColumnDefs = [
  { headerName: "Reference", field: "reference" },
  { headerName: "Quantity", field: "quantity" },
  { headerName: "Weight", field: "weight" },
  { headerName: "Length", field: "length" },
  { headerName: "Width", field: "width" },
  { headerName: "Height", field: "height" },
];

export const quoteColumnDefs = [
  { headerName: "Product ID", field: "productId" },
  { headerName: "Parcel Type", field: "parcelType" },
  { headerName: "Price", field: "price" },
  { headerName: "Reference", field: "reference" },
];
